import { getSigned } from "./account";
import type { ConnectionOptions } from "@foreman/app-core";

/**
 * What each computer last said about this phone's account, kept on the phone. Opening the app shows the saved plan at once
 * instead of the guest "sign in" cards while the computer is reached again. It only ever holds a signed-in answer, belongs to
 * the account that was signed in when it was saved, and is ignored (and dropped) as soon as that account is gone.
 */
const KEY = "foreman.account-cache";
type Saved = Record<string, { email: string; account: NonNullable<ReturnType<NonNullable<ConnectionOptions["accountCache"]>["load"]>> }>;

const read = (): Saved => {
  try {
    return JSON.parse(localStorage.getItem(KEY) ?? "{}") as Saved;
  } catch {
    return {};
  }
};

export const accountCache: NonNullable<ConnectionOptions["accountCache"]> = {
  load(computerId) {
    const me = getSigned();
    if (!me) return null;
    const hit = read()[computerId];
    return hit && hit.email === me.email ? hit.account : null;
  },
  save(computerId, account) {
    const me = getSigned();
    if (!me) return;
    try {
      localStorage.setItem(KEY, JSON.stringify({ ...read(), [computerId]: { email: me.email, account } }));
    } catch {
      /* private mode: just not remembered */
    }
  },
};
